module.exports = __webpack_public_path__ + "static/media/image2.eb7f7ba5.jpg";